import axios, { handleRequest } from "./kiddy-connector";
// ========================================================= API =========================================================
const startBundleExamTestAPI = (examId, bundleId) =>
  axios.get(`/testing/startExamSetInBundle/${examId}/${bundleId}`);
const PostFinishedTestAPI = (examId, bundleId, param) =>
  axios.post(`/testing/finishedExamSetInBundle/${examId}/${bundleId}`, param);
const GetGroupStartTestingAPI = (examId, groupId) =>
  axios.get(`/group/startTesting/${examId}/${groupId}`);
const PostGroupFinishedTestAPI = (examId, groupId, param) =>
  axios.post(`/group/finishedTesting/${examId}/${groupId}`, param);
const ChangeDeviceStartTestingAPI = (param) => {
  if (param.examId && param.bundleId) {
    return axios.get(
      `/testing/changeDeviceStartTestingExamSetInBundle?examId=${param.examId}&bundleId=${param.bundleId}`
    );
  } else {
    return axios.get(
      `/testing/changeDeviceStartTestingExamSetInBundle?testingId=${param.testingId}`
    );
  }
};
const UpdateTestingTutorial = (params) =>
  axios.patch(`/auth/tutorial/${params}`);
// ========================================================= Service =====================================================

export const startTestingService = (examId, bundleId) => {
  return handleRequest(startBundleExamTestAPI(examId, bundleId));
};

export const finishedTestingService = (examId, bundleId, param) => {
  return handleRequest(PostFinishedTestAPI(examId, bundleId, param));
};

export const getGroupStartTestingService = (examId, groupId) => {
  return handleRequest(GetGroupStartTestingAPI(examId, groupId));
};

export const postGroupFinishedTestService = (examId, groupId, param) => {
  return handleRequest(PostGroupFinishedTestAPI(examId, groupId, param));
};

export const ChangeDeviceStartTestingService = (param) => {
  return handleRequest(ChangeDeviceStartTestingAPI(param));
};

export const updateTestingTutorialService = (params) => {
  return handleRequest(UpdateTestingTutorial(params));
};
